var View = require('views/base/view');
var FeedbackView = require('views/feedback/feedback-view');
var ActionBarView = require('views/actionbar/actionbar-view');
var AlertView = require('views/alert/alert-view');
var CustomContentView = require('views/custom-content/custom-content-collection-view');
var BlocksView = require('views/block/block-collection-view');
var Feedback = require('models/feedback');
var CourseSettingsService = require('services/course-settings-service');
import { SessionStorageService } from 'services/web-storage-service';

import { KeybindingService, keys } from 'services/keybinding-service';
var LocaleService = require('services/locale-service');
var ContentService = require('services/content-service');
var TranscriptView = require('views/transcript/transcript-view');
var FeedbackService = require('services/feedback-service');
var PageService = require('services/page-service');
var AnimationService = require('services/animation-service');
var PageTimerService = require('services/page-timer-service');
var ForgeService = require('services/forge-service');
var utils = require('lib/utils');
var ef = require('ef/ef');
var ContentProvider = require('services/content-provider');

var AOS = require('aos');

const { Tab, Enter, Space } = keys;

var PageView = View.extend({
  autoRender: true,
  regions: {
    page: '#page-container',
    timer: '#timer-page',
    actionbar: '.actionbar',
    alert: '.alert',
    siteTranscript: '.site-transcript',
    before: '.before-content',
    feedback: '.feedback',
    'custom-content': '.custom-content',
  },
  template: require('./templates/page'),
  listen: {
    'action:replay mediator': 'onReplay',
    'action:unload mediator': 'unload',
    'block:feedback mediator': 'renderFeedback',
    'action:alert mediator': 'renderAlert',
  },
  initialize: function (_options) {
    var self = this;

    if (CourseSettingsService.get('trackPageTimes') && !EF.options.local) {
      this.pageTimerService = new PageTimerService();
      this.pageTimerService.start();
    }
    if (CourseSettingsService.get('transcript')) {
      this.model.set('transcript', true);
    }
    if (CourseSettingsService.get('skipNavigationAccessibility')) {
      this.model.set('skipNavigationAccessibility', true);
    }
    if (CourseSettingsService.get('pageCompletion') && CourseSettingsService.get('pageCompletion').completeOnError) {
      this.subscribeEvent('application:error', _application => {
        if (self !== undefined && typeof self.completePage === 'function') {
          self.completePage();
        }
      });
    }

    /**
     * CourseSettingsService.
     */

    var that = this;
    $('#site-container').addClass('focus-hide');
    this.delegate('click', '#transcript_button', function (e) {
      e.preventDefault();
      var self = this;
      if (this.transcriptShowing) {
        this.closeTranscript();
      } else {
        Chaplin.mediator.publish('action:pause');
        this.$('#transcript_button').addClass('open');
        var transcriptView = new TranscriptView({
          region: 'siteTranscript',
          model: this.model,
        });
        transcriptView.delegate('click', '.close', function () {
          self.closeTranscript();
          $('#transcript_button').focus();
        });
        this.subview('siteTranscript', transcriptView);
        this.$('.transcript').css('display', 'block');
        // something in the page view grabs focus again, so let's delay slightly
        setTimeout(() => {
          this.$('.transcript .text').attr('tabindex', '0').focus();
        }, 300);
        that.delegate('keydown', '.transcript .text', function (e) {
          KeybindingService.with(e).bind(Tab, () => {
            e.preventDefault();
            this.$('.transcript .close').attr('tabindex', '0').focus();
          });
        });
        this.transcriptShowing = true;
      }
    });

    _.bindAll(this, 'setState');

    let linkedPage = this.model.get('link');
    let scriptPath = linkedPage
      ? ['modules', linkedPage.module, linkedPage.activity, linkedPage.page, linkedPage.page].join('/')
      : [
          'modules',
          this.model.get('moduleKey'),
          this.model.get('activityKey'),
          this.model.get('key'),
          this.model.get('key'),
        ].join('/');

    this.script = utils.tryRequire(scriptPath) || {};

    if (this.model.get('srContent')) {
      var accSettings = CourseSettingsService.get('accessibility');
      if (accSettings && accSettings.skipKey) {
        this.model.set('skipKey', accSettings.skipKey);
        this.model.set('sr_skip_text', LocaleService.t('srSkipText'));
      }
    }

    if (this.model.get('custom-transcript')) {
      this.customTranscriptKey = this.model.get('custom-transcript');
    }

    this.delegate('keydown', function (e) {
      if ($(e.target).prop('tagName') !== 'INPUT' && accSettings && accSettings.skipKey) {
        KeybindingService.with(e).bind([accSettings.skipKey.toUpperCase(), accSettings.skipKey.toLowerCase()], () => {
          if (self.model.get('srContent') && e.shiftKey && e.ctrlKey) {
            self.completePage();
            Chaplin.mediator.publish('page:navigate', self.forwardKey());
          }
        });
      }
    });

    const $el = this.$el;
    if (this.model.get('transition-in')) {
      const transitionInDir = this.model.get('transition-in');
      $el.addClass(`transition-in-${transitionInDir}`);
      $el.on('animationstart', () => {
        $el.on('animationend', () => {
          //console.log(`finished animation in on ${this.model.get('key')}; removing class`);
          if ($el) {
            $el.removeClass(`transition-in-${transitionInDir}`);
          }
        });
      });
    }

    this.listenTo(this.model, 'change:state', function () {
      //TODO: review the timing of this; had to move it in FeedbackView to have it run after callbacks had happened
      self.trigger('page:state:change', self);
      if (self.model) {
        Chaplin.mediator.publish('page:state:' + self.model.get('state'), self);
      }
      Chaplin.mediator.publish('page:stateChange', self);
    });

    this.subscribeEvent('feedback:all:close', function () {
      for (var i = this.subviews.length - 1; i >= 0; i--) {
        if (this.subviews[i] instanceof FeedbackView) {
          this.removeSubview(self.subviews[i]);
        }
      }
    });

    this.subscribeEvent('alert:close', this.closeAlert);

    Chaplin.mediator.subscribe('page:complete', function (options) {
      self.completePage();
      Chaplin.mediator.publish('page:navigate', options.direction);
    });

    if (CourseSettingsService.get('pageCompletion')) {
      let pageCompletion = CourseSettingsService.get('pageCompletion');
      if (pageCompletion.modal) {
        let openModal = function () {
          self.$('#timeout-modal-container').html(require('./templates/timeout'));
          self.$('#timeout-modal').modal('show');
          self.delegate('click', '#timeout-modal .keep-working', () => {
            self.$('#timeout-modal').remove();
            clearTimeout(self.completionTimeout);
            self.completionTimeout = setTimeout(openModal, pageCompletion.timer);
          });
          self.delegate('click', '#timeout-modal .skip-page', () => {
            self.$('#timeout-modal').remove();
            self.completePage();
            Chaplin.mediator.publish('page:navigate', 'forward');
          });
        };
        this.completionTimeout = setTimeout(openModal, pageCompletion.timer);
      } else {
        self.completionTimeout = setTimeout(() => {
          self.completionTimerExpired = true;
          self.completePage();
        }, pageCompletion.timer);
      }
    }

    this.setState('initialized');

    if (PageService.shouldBeSkipped(this)) {
      self.willBeSkipped = true; //defer page navigation until play begins
      self.completePage();
    }

    if (this.model.get('animation')) {
      this.$el.attr('data-anijs', this.model.get('animation'));
    }

    if (this.model.get('onscroll')) {
      const scrollParams = this.model.get('onscroll');
      for (var prop in scrollParams) {
        if (scrollParams.hasOwnProperty(prop)) {
          if (prop === 'animation') {
            this.$el.attr('data-aos', scrollParams[prop]);
          } else {
            this.$el.attr('data-aos-' + prop, scrollParams[prop]);
          }
        }
      }
    }
    View.prototype.initialize.apply(this, arguments);
  },

  play: function () {
    if (this.willBeSkipped) {
      Chaplin.mediator.publish('page:navigate', 'skip');
    } else {
      this.setPrevNextTitle();

      //TODO: revisit trying to reuse the actionbarview, has been moved from the controller
      //this.reuse('actionbar', ActionBarView, {region: 'actionbar'});
      var group = EF.module.get('group');

      var m = new Chaplin.Model({
        groupTitle: group !== undefined ? group.get('title') : '',
        moduleTitle: EF.module.get('title'),
        pageTitle: this.model.get('title'),
        pageProgress: EF.module.getPageProgress(),
        navigation: this.model.get('navigation'),
      });

      var actionBarView = new ActionBarView({
        region: 'actionbar',
        model: m,
      });
      this.subview('actionbar', actionBarView);

      ContentService.applyContent(new Chaplin.Model(), 'modules')
        .then(bm => {
          // Check if a module-key exists on the modules atrribute and set it as the default block module if it exists
          const currentModule = EF.module.get('key');
          const modulesCollection = bm.get(currentModule) && bm.get(currentModule).blocks;
          return modulesCollection
            ? ContentService.applyContent(new Chaplin.Model(), `modules.${currentModule}`)
            : Promise.resolve(bm);
        })
        .then(bm => {
          var modulesBlocksView;
          if (!bm.get('blocks') && ef.forge_mode) {
            bm.set('blocks', new Chaplin.Collection([]));
          }
          if (bm.get('blocks')) {
            modulesBlocksView = new BlocksView({
              //eslint-disable-line no-unused-vars
              collection: bm.get('blocks'),
              region: 'before',
              parent: this,
              pageView: this,
            });
            this.subview('moduleBlocks', modulesBlocksView);
          }

          if (bm.get('blocks') && bm.get('blocks').length > 0) {
            this.setSkipLink();
          } else {
            this.$el.find('#skip-to-main-content').addClass('hidden');
          }

          var blocksView = new BlocksView({
            collection: this.model.get('blocks'),
            region: 'page',
            script: this.script ? this.script.block : undefined,
            parent: this,
            pageView: this,
          });

          this.subview('blocks', blocksView);
          this.listenTo(blocksView, 'block:state:completed', this.blockCompleted);
          this.listenTo(blocksView, 'page:state:change', () => {
            const narration = this.getBlocksNarration(this.model.get('blocks'));
            if (narration.length) {
              this.model.set('transcriptNarration', narration);
              this.$('#transcript_button').css('display', 'block');
            }
          });
          this.setPageTitle();
          const readyToLoad = () =>
            blocksView.isLoaded() && (!modulesBlocksView || (modulesBlocksView && modulesBlocksView.isLoaded()));
          const blocksLoaded = () => {
            this.setState('loaded');
            ForgeService.applyForgeControls();
            ForgeService.applyForgeControls('#main-container > div > .before-content', '.before-content');
            const animateds = $('.animated');
            var self = this;
            var playPage = function () {
              self.$el.attr('tabindex', '-1');
              $('#page-loading').attr('aria-hidden', 'true');

              $(window).scrollTop(0);
              AniJS.run();
              AOS.init();

              if (self.model.get('startAnimation')) {
                AnimationService.queueAnimationsRun();
              }
              animateds.each((i, el) => {
                const classes = el.className;
                el.className = '';
                setTimeout(() => (el.className = classes), 0);
              });
              self.setState('playing');
            };

            var pageCustomizations = ef.customizations.getByKeyAndPage(
              'page-content-customization',
              this.model.get('moduleKey'),
              this.model.get('activityKey'),
              this.model.get('key')
            );

            var customContentView = new CustomContentView({
              region: 'custom-content',
              collection: new Chaplin.Collection(pageCustomizations),
            });
            customContentView.on('done', () => {
              if (this.model.get('instructions')) {
                var feedback = new Feedback(this.model.get('instructions'));
                this.renderFeedback(feedback, { unloading: playPage });
              } else {
                playPage();
              }
            });
            customContentView.render();
            this.subview('custom-content', customContentView);
          };
          if (readyToLoad()) {
            blocksLoaded();
          } else {
            this.listenTo(blocksView, 'block:state:loaded', () => readyToLoad() && blocksLoaded());
            if (modulesBlocksView) {
              this.listenTo(modulesBlocksView, 'block:state:loaded', () => readyToLoad() && blocksLoaded());
            }
          }
        });
    }
  },

  setPrevNextTitle() {
    var prev = PageService.getPreviousPage();
    var next = PageService.getNextPage();
    if (prev) SessionStorageService.setItem('prevTitle', LocaleService.t(prev.get('title')));
    if (next) SessionStorageService.setItem('nextTitle', LocaleService.t(next.get('title')));
  },

  getBlocksNarration(blocks) {
    let transcript = [];
    //Adding absent, present, parameters as transcript was not showing up when audio tag is passed from inside these key
    let nestedItems = ['blocks', 'feedback', 'absent', 'present', 'parameters'].concat(this.nested);
    blocks = [].concat(blocks.models || blocks);
    blocks.forEach(block => {
      if ((block.get && block.get('narration')) || block.narration) {
        transcript.push(LocaleService.t((block.get && block.get('narration')) || block.narration));
      }
      nestedItems.forEach(item => {
        if (block.attributes && block.attributes[item]) {
          transcript.push(...this.getBlocksNarration(block.attributes[item]));
        } else if (block[item]) {
          transcript.push(...this.getBlocksNarration(block[item]));
        }
      });
      if (blocks.subviews) {
        blocks.subviews.forEach(view => {
          if (view instanceof BlocksView) {
            transcript.push(...this.getBlocksNarration(view));
          }
        });
      }
    });
    return transcript;
  },

  onReplay: function () {
    this.setState('playing');
  },
  unload: function () {
    this.setState('unloading');
    this.unsubscribeAllEvents();
  },
  renderFeedback: function (feedback, callbacks) {
    FeedbackService.displayFeedback(this, feedback, callbacks);
  },
  renderAlert: function (type, title, body, icon, visibility) {
    var alertView = new AlertView({
      region: 'alert',
      model: new Chaplin.Model({
        type,
        ico: icon,
        title,
        body,
        visibility,
      }),
    });
    this.subview('alert', alertView);
  },
  closeAlert: function () {
    this.subviewsByName.alert.dispose();
    $('.alert').html('');
  },
  closeTranscript() {
    if (this.subviewsByName.siteTranscript) {
      this.subviewsByName.siteTranscript.dispose();
    }
    this.$('#transcript_button').removeClass('open');
    this.$('.transcript').hide();
    this.transcriptShowing = false;
  },
  setPageTitle: function () {
    const titleAr = [
      LocaleService.t('ModuleName') !== 'ModuleName'
        ? LocaleService.t('ModuleName')
        : LocaleService.t(EF.module.get('title')),
      LocaleService.t(EF.module.currentActivity.get('title')),
      LocaleService.t(EF.module.currentActivity.currentPage.get('title')) ||
        LocaleService.t(this.model.get('page-title')),
    ];

    document.title = _.uniq(titleAr)
      .filter(t => t)
      .join(' | ');
  },
  setSkipLink: function () {
    //Use foundry skip-to-main-content link (#skipLink) if it exists
    if ($('#skipLink').length) {
      $('#skipLink').on('keydown', e => {
        KeybindingService.with(e).bind([Enter, Space], () => {
          this.skipToContent();
        });
      });
    }
    this.$el.on('click', '#skip-to-main-content', e => {
      e.preventDefault();
      this.skipToContent();
    });
  },
  skipToContent: function () {
    const container = $('#page-container').length ? '#page-container' : '#main-container';
    const $focus = $(`${container} :header`).length ? $(`${container} :header`).first() : $(`${container}`);
    $focus.attr('tabindex', -1).focus();
  },
  blockCompleted: function () {
    if (this.subviewsByName.blocks.isComplete()) {
      //TODO: this will fire regardless of if progress saves, which might be OK, but should confirm
      this.completePage();
    }
  },
  dispose: function () {
    $('#page-loading').attr('aria-hidden', false).focus();

    if (this.completionTimeout) {
      clearTimeout(this.completionTimeout);
    }
    if (this.pageTimerService) {
      this.pageTimerService.clear();
    }
    if (this.disposed || this.disposing) {
      return;
    }
    if (this.model && (this.model.get('transition') || CourseSettingsService.get('transitionAll'))) {
      this.disposing = true;
      this.keepElement = true;
      this.keepSubviews(true);
      const $el = this.$el;
      let key = this.model.get('key');
      $el.on('animationstart', () => {
        $el.on('animationend', () => {
          console.log(`finished animation out on ${key}; disposing`); //eslint-disable-line no-console
          $el.remove();
        });
      });
      const transitionOutDir = this.model.get('transition-out') || 'forward';
      //navigation is probably happening too, let that start before we start transitioning
      setTimeout(() => {
        $el
          .removeClass('transition-in-back')
          .removeClass('transition-in-forward')
          .addClass(`transition-out-${transitionOutDir}`);
        View.prototype.dispose.apply(this, arguments);
      }, 0);
    } else {
      this.keepSubviews(true);
      //console.log(`disposing ${this.model.get('key')} without animation`);
      View.prototype.dispose.apply(this, arguments);
    }
  },
  completePage: function () {
    //TODO: review this in relation to the existing events in EF
    if (this.completionTimeout) {
      clearTimeout(this.completionTimeout);
    }
    if (CourseSettingsService.get('trackPageTimes') && !EF.options.local) {
      this.pageTimerService.save({
        page_key: this.model.get('key'),
        activity_key: this.model.get('activityKey'),
        module_key: this.model.get('moduleKey'),
      });
    }
    this.model.set('completed', true);
    ContentProvider.PageService.saveProgress(this);
    if (EF.module && EF.module.progress && this.model.has('followers') && Array.isArray(this.model.get('followers'))) {
      this.model.get('followers').forEach(follower => {
        EF.module.progress.savePage(
          {
            attributes: {},
            trigger: key => Chaplin.mediator.publish(key, follower),
          },
          {
            module_key: EF.module.get('key'),
            content_id: EF.enrollment.get('contentId'),
            activity_key: follower.activityKey,
            key: follower.pageKey,
            page_key: follower.pageKey,
            index: follower.index,
          },
          () => {}
        );
      });
    }
    this.setState('completed');
  },
  stateCallbacks: {
    completed: function () {
      if (this.model.get('completedFeedback') && !this.completionTimerExpired) {
        var feedback = new Feedback(this.model.get('completedFeedback'));
        if (this.model.get('forwardOnComplete') && !this.willBeSkipped) {
          this.renderFeedback(feedback, {
            afterRemoved: () => {
              Chaplin.mediator.publish('page:navigate', this.forwardKey());
            },
          });
        } else {
          this.renderFeedback(feedback);
        }
      } else {
        if (this.model.get('forwardOnComplete') && !this.willBeSkipped) {
          Chaplin.mediator.publish('page:navigate', this.forwardKey());
        }
      }
      if (Object.isExtensible(this)) {
        this.completionTimerExpired = false;
      }
    },
    unloading: function () {
      //console.log(`unloading ${this.model.get('key')}`);
      this.setState('unloaded');
    },
    unloaded: function () {
      //console.log(`unloaded ${this.model.get('key')}, starting disposal`);
      this.dispose();
    },
  },
  setState: function (state) {
    if (this.model) {
      if (this.$el) {
        this.$el.removeClass(this.model.get('state'));
        this.$el.addClass(state);
      }
      this.model.set('state', state);
    }

    var callback = this.stateCallbacks[state] ? _.bind(this.stateCallbacks[state], this) : null;
    var hook = this.script && this.script[state] ? _.bind(this.script[state], this.script) : null;

    if (hook && callback) {
      if (this.script[state].length === 2) {
        hook(this, callback);
      } else {
        hook(this);
        callback();
      }
    } else if (hook) {
      hook(this);
    } else if (callback) {
      callback();
    }
  },
  forwardKey: function () {
    return this.model.get('navigation') && this.model.get('navigation').forward
      ? this.model.get('navigation').forward
      : 'forward';
  },
});

module.exports = PageView;
